import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { initPwaInstall } from './utilities/pwaInstall';
import { installAuthInterceptor } from './utilities/authInterceptor';

initPwaInstall();
installAuthInterceptor(); // Bearer token on every API call (see utilities/authToken.js)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store}>

    <App />

  </Provider>
  
   
 
);

